import { jsx, jsxs } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ jsxs("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: [
  /* @__PURE__ */ jsx("circle", { cx: 16, cy: 16, r: 16, fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx("path", { d: "M14.875 17.125V22.75H17.125V17.125H22.75V14.875H17.125V9.25H14.875V14.875H9.25V17.125H14.875Z", fill: "white" })
] });
export default SvgPlus;
